import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import PaneWrapper from './PaneWrapper'
import TabNav from '../../shared/components/TabNav'
import TabContent from '../../shared/components/TabContent'
import TabOpen from './TabOpen'
import TabDeclined from './TabDeclined'
import TabDeactivated from './TabDeactivated'

export default class Pane extends Component {

  static propTypes = {
    data: PropTypes.object,
    onLoad: PropTypes.func
  }

  constructor() {
    super()
    this.tabs = [
      { title: 'Offen', value: 'open', Comp: TabOpen },
      { title: 'Abgelehnt', value: 'declined', Comp: TabDeclined },
      { title: 'Deaktiviert', value: 'deactivated', Comp: TabDeactivated }
    ]
    this.state = {
      activeTab: 'open'
    }
  }

  @autobind
  handleRenderTab(tabName) {
    const tab = this.tabs.find((currTab) => currTab.value === tabName)
    const Tab = tab.Comp
    return <Tab data={this.props.data} />
  }

  @autobind
  handleTabChange({ target }) {
    this.setState({ activeTab: target.value })
  }

  render() {

    return (
      <PaneWrapper>

        <h1 className="with-tools">
          Anfragen zur Freigabe
          <span className="tools">
            <button
              className="btn btn-sm btn-default"
              onClick={this.props.onLoad}
            >
              Aktualisieren
            </button>
          </span>
        </h1>

        <div role="tabpanel">

          <TabNav
            active={this.state.activeTab}
            tabs={this.tabs}
            onTabChanged={this.handleTabChange}
          />

          <TabContent
            active={this.state.activeTab}
            tabs={this.tabs}
            renderTab={this.handleRenderTab}
          />

        </div>
      </PaneWrapper>
    )
  }

}
/*

<li className="release iconized">
  <div className="">
    <svg className="nav-list-icon" width="18" height="18">
        <use
          xlinkHref="#icon-house-grey"
        />
    </svg>

Allgäuer Burgenmuseum <br />
<small>zuletzt aktualisiert 25.11.2016, 00:00 Uhr</small>

<span className="tools">
<a href="#!/release/museum/m2/versions" title="Freigabe bearbeiten" data-placement="top" data-toggle="tooltip">
    <svg className="tool-icon" width="18" height="18"><use
      xlinkHref="#icon-pencil-turquoise"
    /></svg>
</a>
</span>

</div>
</li>

*/



// WEBPACK FOOTER //
// ./src/release/components/Pane.js